import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseButtonSize } from '../../../../../shared/components/button/base-button.component';
import { AddressFormInterface, BillingAddressFormInterface } from '../../../_interfaces/base-administration.interface';

@Component({
  selector: 'base-master-address-form',
  templateUrl: './base-master-address-form.component.html',
})
export class BaseMasterAddressFormComponent {
  @Input() form: FormGroup<AddressFormInterface> | FormGroup<BillingAddressFormInterface>;
  @Input() isEditMode = false;
  @Input() submitted = false;
  @Input() isBillingAddress = false;
  @Input() headline = '';
  @Input() subTitle = '';
  @Output() sameAsBusiness: EventEmitter<boolean> = new EventEmitter<boolean>();
  buttonSizes = BaseButtonSize;

  copyFromBusinessAddress(): void {
    this.sameAsBusiness.emit(true);
  }

  isBillingAddressForm(
    form: FormGroup<AddressFormInterface> | FormGroup<BillingAddressFormInterface>
  ): form is FormGroup<BillingAddressFormInterface> {
    return 'legalName' in form.controls || 'email' in form.controls;
  }
}
